import { Component, Inject, OnInit } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { base64ToFile, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';

import CONSTANTS from '../../../_constants/constants';

@Component({
  selector: 'app-crop-image',
  templateUrl: './crop-image.component.html',
})
export class CropImageComponent implements OnInit {
  modalTitle = this.data.title;
  width = this.data.params.width || CONSTANTS.ITEM_IMAGE_WIDTH;
  height = this.data.params.height || CONSTANTS.ITEM_IMAGE_HEIGHT;

  sendingForm = false;

  imageChangedEvent: any = '';
  croppedImage: any = '';
  scale = 1;
  showCropper = false;
  containWithinAspectRatio = false;
  transform: ImageTransform = {};

  constructor(
    private ref: MatDialogRef<CropImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    // console.log('CropImageComponent');
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  imageLoaded() {
    // console.log('imageLoaded');
  }

  cropperReady() {
    // console.log('cropperReady');
  }

  loadImageFailed() {
    // console.log('loadImageFailed');
  }

  zoomOut() {
    this.scale -= 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale,
    };
  }

  zoomIn() {
    this.scale += 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale,
    };
  }

  resetImage() {
    this.scale = 1;
    this.transform = {};
  }

  startCropImage() {
    const file = base64ToFile(this.croppedImage);

    const obj = {
      file: file,
      croppedImage: this.croppedImage,
    };

    this.ref.close(obj); // close the dialog
  }

  close() {
    this.ref.close();
  }
}

// const file = base64ToFile(this.imageChangedEvent.target.files[0]);

// const file = this.imageChangedEvent.target.files[0];

// this.ref.close(this.croppedImage); // close the dialog
// this.ref.close(file); // close the dialog

/*
// import { Dimensions, ImageCroppedEvent, ImageTransform } from './image-cropper/interfaces/index';
// import {base64ToFile} from './image-cropper/utils/blob.utils';

  // ElementRef
  // @ViewChild('imageBox') imageBox: ElementRef;
  // @ViewChild('thumbBox') thumbBox: ElementRef;
  // @ViewChild('btnCenterImage') btnCenterImage: ElementRef;
  // @ViewChild('btnZoomIn') btnZoomIn: ElementRef;
  // @ViewChild('btnZoomOut') btnZoomOut: ElementRef;
  // @ViewChild('btnCropImage') btnCropImage: ElementRef;

*/

// const file2 = base64ToFile(this.croppedImage);
// console.log(file2);

// const file3 = this.base64ToFile(this.croppedImage, this.imageChangedEvent.target.files[0].name);
// console.log(file3);

// private base64ToFile(data, filename) {
//   const arr = data.split(',');
//   const mime = arr[0].match(/:(.*?);/)[1];
//   const bstr = atob(arr[1]);
//   let n = bstr.length;
//   let u8arr = new Uint8Array(n);

//   while (n--) {
//     u8arr[n] = bstr.charCodeAt(n);
//   }

//   return new File([u8arr], filename, { type: mime });
// }

/*
ngAfterViewInit() {
  // this.options.imgSrc = e.target.result;
  // load existing image ??

  this.cropbox = new Cropbox(this.imageBox.nativeElement, this.options);
}

selectImage(event) {
  const files = event.target.files;

  const reader = new FileReader();

  this.options.imgSrc = files[0];

  this.cropbox = new Cropbox(this.imageBox.nativeElement, this.options);

  reader.readAsDataURL(files[0]);
} 

cropImage() {
    console.log('cropImage');

    // const img = this.cropbox.getDataURL()
    // document.querySelector('.cropped').innerHTML += '<img src="'+img+'">';

    // this.ref.close(player);
  }

  centerImage() {
    console.log('centerImage');
    // cropper = $('#' + itemId + '-crop-imageBox').cropbox(options); // jQuery // TODO: willy - check
  }

*/

/*

// import Cropbox from '../../../../assets/js/ng-cropbox';

  // options = {
    // imageBox: '.imageBox',
    // thumbBox: '.thumbBox',
    // spinner: '.spinner',
    // imgSrc: '',
    // imgSrc: CONSTANTS.DEFAULT_IMAGE,
  // };

  // private fileName = '';
  // private cropbox: Cropbox;

*/
